export const MetaData = {
    home: {
        title: 'Agile24x7 | Task Management Software',
        description: 'Welcome to Agile24x7! Manage tasks efficiently to grow your business. Get organized, boost productivity, and empower your team with Agile24x7.',
        keywords: 'task management software, productivity, team collaboration, business growth'
    },
    contact: {
        title: 'Contact Us | Agile24x7',
        description: 'Get in touch with Agile24x7! Reach out to our team for any inquiries, feedback, or support. We’re here to help you succeed.',
        keywords: 'contact us, support, feedback, customer service'
    },
    login: {
        title: 'Log In | Agile24x7',
        description: 'Log in to Agile24x7 and access your account. Streamline task management, track progress, and collaborate with your team effortlessly.',
        keywords: 'login, sign in, account access, task management platform'
    },
    register: {
        title: 'Sign Up | Agile24x7',
        description: 'Sign up for Agile24x7 and start managing tasks effectively. Join thousands of businesses using Wetasker to achieve greater efficiency and success.',
        keywords: 'sign up, register, task management platform, business efficiency'
    },
    careers: {
        title: 'Careers at Agile24x7',
        description: 'Explore career opportunities at Agile24x7 and join our dynamic team. We’re always looking for talented individuals passionate about making a difference.',
        keywords: 'careers, job opportunities, employment, join our team'
    },
    partners: {
        title: 'Partners | Agile24x7',
    },
    faq: {
        title: 'FAQs | Agile24x7',
        description: 'Find answers to frequently asked questions about Agile24x7. Learn how our task management software works and how it can benefit your business.',
        keywords: 'FAQs, frequently asked questions, task management software, help'
    },
    release: {
        title: 'Release Notes | Agile24x7',
        description: 'Stay updated with the latest release notes from Agile24x7. Discover new features, enhancements, and bug fixes to improve your task management experience.',
        keywords: 'release notes, updates, new features, task management software'
    },
    privacyPolicy: {
        title: 'Privacy Policy | Agile24x7',
        description: 'Read Agile24x7’s privacy policy to understand how we collect, use, and protect your personal information. Your privacy and security are our top priorities.',
        keywords: 'privacy policy, data protection, personal information, security measures'
    },
    forgotPassword: {
        title: 'Forgot Password | Agile24x7',
        description: 'Forgot your password? No worries! Recover your account password with Agile24x7’s password reset feature. Keep your account secure and get back to work.',
        keywords: 'forgot password, password recovery, account security, reset password'
    },
    bugReport: {
        title: 'Bug Report | Agile24x7',
        description: 'Report a bug or issue with Agile24x7. Help us improve our platform by providing detailed information about any problems you encounter. Your feedback is valuable to us!',
        keywords: 'bug report, issue reporting, platform improvement, feedback'
    },
}
